import { render } from "./passwordLogin.vue?vue&type=template&id=05e5ab30&scoped=true&ts=true"
import script from "./passwordLogin.vue?vue&type=script&lang=ts"
export * from "./passwordLogin.vue?vue&type=script&lang=ts"

import "./passwordLogin.vue?vue&type=style&index=0&id=05e5ab30&lang=less"
import "./passwordLogin.vue?vue&type=style&index=1&id=05e5ab30&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@4.5.5__webpack@5.106.2_e1bdad7a4b23a28f51493789fcc92ed5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e5ab30"]])

export default __exports__